import { DeduplicationPool } from 'helpers/DeduplicationPool/DeduplicationPool';
import {
  action, configure, makeAutoObservable, observable,
  runInAction,
} from 'mobx';
import { TUpdateUserProfile, UserProfile } from 'stores/types/Profiles';

import apiClient from '../apiClient';

configure({
  enforceActions: 'observed',
  isolateGlobalState: true,
  reactionRequiresObservable: true,
});

class UserStore {
  userProfile: UserProfile | null = null;
  isUserProfileLoaded = false;

  deduplicationPool = new DeduplicationPool();

  constructor() {
    makeAutoObservable(this, {
      userProfile: observable,
      isUserProfileLoaded: observable,
      getUserProfile: action,
      setUserProfile: action,
      setPetDNADisplayName: action,
      setMeasurementPreference: action,
      reloadProfile: action,
    });
  }

  getUserProfile = async () => {
    this.isUserProfileLoaded = false;
    await this.deduplicationPool.runTask('getUserProfile', async () => {
      const profileResponse = await apiClient.user.getUserProfile();
      runInAction(() => {
        if (profileResponse?.data) {
          this.userProfile = profileResponse.data;
          this.isUserProfileLoaded = true;
        }
      });
    });
  };

  reloadProfile = async () => {
    const profileResponse = await apiClient.user.getUserProfile();
    runInAction(() => {
      if (profileResponse?.data) {
        this.userProfile = profileResponse.data;
      }
    });
  };

  setPetDNADisplayName = async (displayName:string) => {
    await apiClient.user.setPetDNADisplayName(displayName);
    await this.reloadProfile();
  };

  setMeasurementPreference = async (measurementPreference:string) => {
    const profileResponse = await apiClient.user.setMeasurementPreference(measurementPreference);
    if (profileResponse.data) {
      this.userProfile = profileResponse.data;
    }
  };

  setAllMessagesOn = async (isDoNotContact:boolean) => {
    const profileResponse = await apiClient.user.setAllMessagesOn(isDoNotContact);
    if (profileResponse.data) {
      this.userProfile = profileResponse.data;
    }
  };

  setUserProfile(profile: UserProfile | null) {
    this.userProfile = profile;
  }

  updateUserProfile = async (profile: TUpdateUserProfile) => {
    await apiClient.user.updateUserProfile(profile);
    await this.reloadProfile();
  };
}

export default UserStore;
